import HeroCarousel from './components/HeroCarousel';
import CategoryQuickLinks from './components/CategoryQuickLinks';
import LatestRail from './components/LatestRail';
import SiteIntro from './components/SiteIntro';
import SectionHeading from '@/components/feature/SectionHeading';
import MovieGrid from '@/components/feature/MovieGrid';
import { getFeatured, getLatest, getPopular } from '@/utils/movieUtils';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';

export default function Home() {
  useDocumentMeta({
    title: '午夜视频 - 精选影视资源与最新视频内容聚合平台',
    description:
      '午夜视频为您提供丰富的电影、电视剧和短视频内容，涵盖多种类别与题材，助您畅享优质影像体验。探索更多精彩影视资源尽在午夜视频。',
    keywords: '午夜视频,影视资源,电影视频,电视剧集,午夜影视,高清影视,视频播放',
  });

  const featured = getFeatured();
  const latest = getLatest(14);
  const popular = getPopular(10);

  return (
    <div className="pt-16 md:pt-20">
      <HeroCarousel items={featured} />
      <CategoryQuickLinks />

      <section className="px-4 md:px-8 py-8 md:py-10">
        <SectionHeading
          icon="ri-time-line"
          title="最新上架"
          subtitle="近期更新的影视资源，第一时间发现新片"
          moreTo="/category/movie"
          moreLabel="全部分类"
        />
        <LatestRail items={latest} />
      </section>

      <section className="px-4 md:px-8 py-8 md:py-10">
        <SectionHeading
          icon="ri-fire-line"
          title="热门推荐"
          subtitle="口碑与人气兼具的精选作品"
          moreTo="/category/series"
          moreLabel="更多剧集"
        />
        <MovieGrid items={popular} />
      </section>

      <SiteIntro />
    </div>
  );
}